module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.invoice) ? _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.show
    }
  }, [_c('a', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "btn btn-clear float-right",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title h5"
  }, [_vm._v("Send invoice")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "input-example-3"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('quillEditor', {
    attrs: {
      "id": "editor",
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.sending
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.send($event)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), (_vm.sendError) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v("Something went wrong")]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10dc828a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/sendInvoiceModal.vue
// module id = 477
// module chunks = 1